<template>
  <div id="app" class="v-application--wrap layout-centered" :class="layoutClass">
    <div class="layout-centered--background">&nbsp;</div>
    <slot name="header">
      <div class="header">
        <img width="130" :alt="extendedConfig.VUE_MAIN_TITLE" src="../assets/kr.png" />
      </div>
    </slot>
    <v-content>
      <v-container fluid fill-height>
        <v-layout :align-center="alignCenter" justify-center flex-wrap>
          <slot>
            <router-view />
          </slot>
        </v-layout>
      </v-container>
    </v-content>
    <slot name="footer">
      <div class="footer">
        © {{ new Date().getFullYear() }} by {{extendedConfig.VUE_MAIN_TITLE}}.
      </div>
    </slot>
  </div>
</template>

<script>
import extendedConfig from "../tenants.js";
export default {
  name: "LayoutCentered",
  props: {
    layoutClass: {
      type: String,
      default: ''
    },
    alignCenter: {
      type: Boolean,
      default: true
    }
  },
  components: {},

  data: () => ({
    //
  })
};
</script>
<style lang="scss">
.layout-centered {
  background: url(../assets/bg.jpg) no-repeat center center;
  background-size: cover;

  &--background {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;

    &::before {
      content: " ";
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: url(../assets/bg-waves.png) no-repeat top left;
      height: 100%;
      background-size: 100% auto;
    }
  }
  .footer {
    position: relative;
    font-size: 9px;
    line-height: 1.55;
    font-weight: 400;
    padding: 12px;
    text-align: center;

    @media (min-width: 768px) {
      text-align: left;
      padding: 24px 40px;
    }
  }
  .header {
    position: relative;
    text-align: center;
    padding: 12px;

    @media (min-width: 768px) {
      text-align: right;
      padding: 24px 40px;
    }
    img {
      margin-top: 8px;
    }
  }
}
</style>
